import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import FjInterestsDetail from './FjInterestsDetail.jsx';
import { Spinner } from '../../../../../common/index.jsx';
import { useGetFjInterestedQuery } from '../../../../../../redux/services/fj_jobs.jsx';
import useIsUserAdmin from '../../../../../../hooks/useIsUserAdmin.jsx';

const FjInterestedPage = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const isAdmin = useIsUserAdmin();

  const {
    data: interestedData,
    isLoading,
    refetch: refetchInterestedData,
  } = useGetFjInterestedQuery(id);

  useEffect(() => {
    document.title = t('Zoznam záujemcov o pracovnú ponuku - FRI.jobs');
  }, []); // Runs on mount

  const jobTitle =
    Array.isArray(interestedData) && interestedData.length > 0
      ? interestedData[0]?.jobTitle
      : undefined;

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={
          t('Zoznam záujemcov o pracovnú ponuku') + ': ' + (jobTitle || '-')
        }
        backUrl={-1}
        backUrlTooltip={t('Nástenka')}
      />
      <div style={{ margin: '10px' }}>
        <FjInterestsDetail
          interestedData={interestedData}
          refetchInterestedData={refetchInterestedData}
          canDeleteInterest={isAdmin}
        />
      </div>
    </>
  );
};

export default FjInterestedPage;
